<app-notifications />
<app-navbar />
<div class="content my-12.5 xl:my-0 p-2 md:p-0">
  @defer (on viewport; prefetch on idle) {
    <router-outlet />
  } @placeholder {
    <div class="min-h-105 p-4">
      <div class="h-full flex items-center justify-center">
        <span
          class="h-5 w-5 rounded-full border-2 border-gray-300 border-t-transparent animate-spin"
        ></span>
      </div>
    </div>
  }
</div>
